import { render } from "./UserProfileFollowersSection.vue?vue&type=template&id=40e6d409"
import script from "./UserProfileFollowersSection.vue?vue&type=script&lang=js"
export * from "./UserProfileFollowersSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__